<template>
  <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="show">
    <template v-slot:activator="{on}">
      <v-btn v-on="on" fab fixed top right color="blue darken-3">
        <v-icon>mdi-history</v-icon>
      </v-btn>
    </template>
    <v-card class="history-detail">
      <v-btn fab fixed top left color="white" outlined><span class="white--text headline">{{feeds.length}}</span></v-btn>
      <v-btn fab fixed top right @click="show = false" color="error">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <div class="title">Feeds for {{ dateText }}</div>
      <table>
        <tr>
          <td>
            <date-selector v-model="date"/>
          </td>
          <td>
            Time<br/>
            <span class="average">Avg: {{averageGap}}</span>
          </td>
          <td>
            <v-btn fab dark small depressed color="pink">{{counts.l}}</v-btn>
            <v-btn fab dark small depressed color="teal">{{counts.r}}</v-btn>
          </td>
        </tr>
        <template v-for="feed in feeds">
          <history-row :key="feed.id" :feed="feed" @edit="edit(feed)"/>
        </template>
      </table>
      <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="showEdit">
        <feed-editor title="Edit a Feed" @close="showEdit = false" @saved="doneEditing" :feed="editFeed"/>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import FeedEditor from './FeedEditor';
import {mapActions} from 'vuex';
import moment from 'moment';
import HistoryRow from './HistoryRow';
import dataWithId from '../lib/doc';
import DateSelector from './DateSelector';

export default {
  name: 'History',
  components: {DateSelector, HistoryRow, FeedEditor},
  data() {
    return {
      date: moment().format('YYYY-MM-DD'),
      feeds: [],
      show: false,
      showEdit: false,
      editFeed: {}
    };
  },
  computed: {
    averageGap() {
      let times = this.feeds.map(feed => moment.utc(feed.startedAt.toDate()));
      if (times.length < 2) {
        return '0:00';
      }
      let total = 0;
      for (let i = 1; i < times.length; i++) {
        total += moment.duration(times[i].diff(times[i - 1]));
      }
      let average = moment.duration(total / (times.length - 1));
      return average.hours() + ':' + (average.minutes() < 10 ? '0' : '') + average.minutes();
    },
    dateText() {
      return moment(this.date, 'YYYY-MM-DD').calendar(null, {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'dddd',
        lastDay: '[Yesterday]',
        lastWeek: 'dddd',
        sameElse: 'DD/MM/YYYY'
      });
    },
    counts() {
      let l = 0;
      let r = 0;
      for (let feed of this.feeds) {
        if (feed.both) {
          l++;
          r++;
        } else if (feed.first === 'L') {
          l++;
        } else {
          r++;
        }
      }
      return {l, r};
    }
  },
  watch: {
    date: {
      handler() {
        this.getFeeds();
      },
      immediate: true
    },
    show() {
      if (this.show) {
        const today = moment().format('YYYY-MM-DD');
        if (this.date !== today) {
          this.date = today;
        } else {
          this.getFeeds();
        }
      }
    }
  },
  methods: {
    ...mapActions('feeds', [
      'getFeedsFor'
    ]),
    doneEditing() {
      this.showEdit = false;
      this.getFeeds();
    },
    edit(feed) {
      this.$logger.info('edit');
      this.editFeed = feed;
      this.showEdit = true;
    },
    getFeeds() {
      this.getFeedsFor(this.date)
          .then(feeds => this.feeds = feeds.docs.map(dataWithId))
          .catch(err => this.$logger.error(err));
    }
  }
}
</script>

<style>
  .history-detail {
    text-align: center;
  }
  .history-detail .title {
    color: rgba(216, 216, 216, 0.5);
    height: 85px;
    line-height: 85px !important;
  }

  .history-detail table {
    font-size: large;
    margin: 0 auto;
    min-width: 50vw;
    border-collapse: collapse;
    border-style: hidden;
  }

  .history-detail td:last-child {
    text-align: left;
  }
  .history-detail td:nth-child(2) {
    min-width: 128px;
  }

  .history-detail table td, .history-detail table th {
    border: 1px solid rgba(216, 216, 216, 0.5);
    padding: 5px;
    transition: 0.5s;
  }

  .history-detail .hide {
    color: black;
  }
</style>
